import React, { useEffect, useState } from "react";

const slides = [
  "assets/images/bg/one-banner.png",
  "assets/images/bg/two-banner.png",
  "assets/images/bg/three-banner.png",
  "assets/images/bg/four-banner.png",
  "assets/images/bg/five-banner.png",
];

const BannerTwo = () => {
  const [active, setActive] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const timer = setInterval(
      () => setActive((i) => (i + 1) % slides.length),
      3000,
    );
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => {
      clearInterval(timer);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return (
    <section className="main-banner-section mt-24">
      <div className="container container-lg">
        <div
          style={{
            position: "relative",
            width: "100%",
            height: isMobile ? 130 : 580,
            overflow: "hidden",
            borderRadius: 20,
          }}
        >
          {slides.map((src, i) => (
            <img
              key={src}
              src={src}
              alt={`Banner ${i + 1}`}
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center",
                opacity: i === active ? 1 : 0,
                transition: "opacity 1s ease-in-out",
                display: "block",
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BannerTwo;
